import React from "react";
import Helmet from "react-helmet";
import PropTypes from "prop-types";

import "../css/_reset.css";
import "../css/default.css";
import "../css/menu.css";
import "../css/main.css";
import "../css/form.css";
import "../css/image.css";
import "../css/cart.css";
import "../css/partials/add-nights.css";
import "../css/partials/angle-banner.css";
import "../css/partials/banner.css";
import "../css/partials/book-callout.css";
import "../css/partials/bookmark-arrow.css";
import "../css/partials/cards.css";
import "../css/partials/confirmation.css";
import "../css/partials/coupon-field.css";
import "../css/partials/coupon-reminder.css";
import "../css/partials/countdown.css";
import "../css/partials/covid-callout.css";
import "../css/partials/destination-callout.css";
import "../css/partials/footer.css";
import "../css/partials/faq-callout.css";
import "../css/partials/gallery.css";
import "../css/partials/header.css";
import "../css/partials/image-slider.css";
import "../css/partials/itinerary.css";
import "../css/partials/lineup.css";
import "../css/partials/modal.css";
import "../css/partials/monthly-payments-callout.css";
import "../css/partials/newsletter-callout.css";
import "../css/partials/notification.css";
import "../css/partials/past-trips.css";
import "../css/partials/past-people.css";
import "../css/partials/phone-callout.css";
import "../css/partials/photos-callout.css";
import "../css/partials/prev-next.css";
import "../css/partials/review-card.css";
import "../css/partials/reviews-callout.css";
import "../css/partials/room-ribbon.css";
import "../css/partials/social-bar.css";
import "../css/partials/sold-out-bar.css";
import "../css/partials/splash.css";
import "../css/partials/summary.css";
import "../css/partials/tabbed-content.css";
import "../css/partials/thin-bar.css";
import "../css/partials/timeline.css";
import "../css/partials/transfer-room-cards.css";
import "../css/partials/transfer-room-selector.css";
import "../css/partials/traveler-summary.css";
import "../css/partials/trip-header.css";
import "../css/partials/youre-going.css";
import "../css/partials/video-row.css";
import "../css/partials/vimeo-player.css";
import "../css/pages/onlocation.css";
import "../css/pages/prices.css";
import "../css/pages/reviews.css";
import "../css/pages/room.css";
import "../css/pages/transfer-form.css";
import "../css/pages/trip.css";
import "../css/_print.css";

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="Christian Travel for Couples | Love Song Couples Getaway"
      meta={[
        {
          name: "description",
          content:
            "Check out this unique Christian Travel experience for couples " +
            "at The Ritz-Carlton, Cancun and The Ritz-Carlton, Kapalua in Maui!",
        },
        { name: "og:site_name", content: "Love Song Couples Getaway" },
        { name: "og:image", content: "/images/facebookpreview.jpg" },
        { name: "fb:admins", content: "100000663021171" },
        { charSet: "utf-8" },
        { httpEquiv: "X-UA-Compatible", content: "IE=edge" },
        {
          name: "viewport",
          content:
            "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0",
        },
        {
          name: "cache-control",
          content: "public, max-age=0, must-revalidate",
        },
        { name: "Pragma", content: "no-cache" },
      ]}
      link={[
        { rel: "icon", type: "image/x-icon", href: "/images/favicon.png" },
        {
          rel: "stylesheet",
          href:
            "https://fonts.googleapis.com/css?family=Montserrat:300,400,500,600",
        },
      ]}
      script={[
        { src: "https://use.fontawesome.com/fda3474895.js" },
        {
          src:
            "//cdnjs.cloudflare.com/ajax/libs/classlist/2014.01.31/classList.min.js",
        },
        { src: "https://js.stripe.com/v3/" },
        { src: "/js/app.js" },
        { src: "/js/adroll.js" },
      ]}
    />
    {children()}
  </div>
);

TemplateWrapper.propTypes = {
  children: PropTypes.func,
};

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js